import React from 'react';
import {Theme} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';


const FullScreenPage: React.FC = (props) => {
    const useStyles = makeStyles((theme: Theme) => ({
        root: {
            flexGrow: 1,
            width: '100%',
            height: '100%',
        },
    }));
    const classes = useStyles();
    return (
            <div className={classes.root}>
                {props.children}
            </div>
    )
};

export default FullScreenPage;
